import { Context, RemovePaymentDetailsParams } from '../../../types';
import { PaymentDetails } from '@vsf-enterprise/sap-commerce-webservices-sdk';
import { RemovePaymentDetailsProps } from '@vsf-enterprise/sapcc-api';
import { createBasePropsFromCustomQuery } from '../../../helpers/createBasePropsFromCustomQuery';

export async function removePaymentDetails(
  context: Context,
  params: RemovePaymentDetailsParams
): Promise<PaymentDetails[]> {
  const { paymentDetailsId, customQuery, paymentDetailsList } = params;
  const props: RemovePaymentDetailsProps = {
    paymentDetailsId,
    ...createBasePropsFromCustomQuery(customQuery)
  };

  await context.$sapcc.api.removePaymentDetails(props);
  return paymentDetailsList.filter((e) => e.id !== paymentDetailsId);
}
